import React, { Component, Fragment } from 'react';
import { Button, UncontrolledTooltip } from 'reactstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { injectIntl, intlShape } from 'react-intl';

import Icon from '../../common/Icon';
import globalTranslations from '../../../i18n/globalTranslations';

export class CartIcon extends Component {
  buttonElement = null;
  state = {
    buttonMounted: false
  };

  setButtonElement = (ref) => {
    this.buttonElement = ref;
    this.setState({ buttonMounted: true });
  };

  render() {
    const {
      intl,
      loading,
      onClick,
      disabled,
      tooltipMessage,
      notAllowed
    } = this.props;
    return (
      <Fragment>
        <Button
          color="primary"
          className={classNames('CartIcon', {
            'CartIcon--not-allowed': notAllowed
          })}
          innerRef={this.setButtonElement}
          onClick={onClick}
          disabled={disabled}
          aria-label={intl.formatMessage(globalTranslations.addToCartButton)}
        >
          <Icon
            name={loading ? 'circle-o-notch' : 'shopping-cart'}
            spin={loading}
          />
        </Button>
        {tooltipMessage &&
          this.state.buttonMounted && (
            <UncontrolledTooltip placement="top" target={this.buttonElement}>
              {tooltipMessage}
            </UncontrolledTooltip>
          )}
      </Fragment>
    );
  }
}

CartIcon.propTypes = {
  intl: intlShape.isRequired,
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  notAllowed: PropTypes.bool,
  tooltipMessage: PropTypes.node
};

export default injectIntl(CartIcon);



// WEBPACK FOOTER //
// ./src/components/cart/CartIcon/index.jsx